// src/contexts/AssistantContext.js
import React, { createContext, useContext, useState } from 'react';

const AssistantContext = createContext();

export const useAssistantContext = () => {
  return useContext(AssistantContext);
};

export const AssistantProvider = ({ children }) => {
  // --- Défilement automatique ---
  const [autoScroll, setAutoScroll] = useState(false);
  const toggleAutoScroll = () => setAutoScroll(v => !v);

  // --- Choix du modèle IA ---
  const [useClaudeModel, setUseClaudeModel] = useState(false);
  const [modelSwitchMessage, setModelSwitchMessage] = useState('');
  const claudeEnabled = process.env.REACT_APP_CLAUDE_ENABLED === 'true';

  const handleModelSwitch = () => {
    setUseClaudeModel(prev => {
      const newValue = !prev;
      const modelName = newValue ? 'Claude (Anthropic)' : 'Mistral';
      setModelSwitchMessage(`Modèle IA basculé sur ${modelName}`);
      setTimeout(() => setModelSwitchMessage(''), 3000);
      return newValue;
    });
  };

  // --- Mode de réponse : Rapide (défaut) / Approfondi ---
  const [deepMode, setDeepMode] = useState(false);
  const toggleDeepMode = () => setDeepMode(v => !v);

  const value = {
    // Défilement automatique
    autoScroll,
    toggleAutoScroll,
    // Modèle IA
    useClaudeModel,
    modelSwitchMessage,
    handleModelSwitch,
    claudeEnabled,
    // Mode de réponse
    deepMode,
    toggleDeepMode,
  };

  return (
    <AssistantContext.Provider value={value}>
      {children}
    </AssistantContext.Provider>
  );
};
